// Components/Header.js — Solponiente
import React from "react";

const Header = ({ subtitle = "Área de Gestión" }) => {
  return (
    <header className="mb-4" style={{ backgroundColor: "#ffffff", borderBottom: "1px solid var(--sp-border-strong)" }}>
      <nav className="navbar navbar-expand navbar-light px-3">
        <div className="navbar-brand d-flex align-items-center">
          <span className="fw-bold text-primary">SOLPONIENTE</span>
          <span className="text-muted ms-2">{subtitle}</span>
        </div>
      </nav>
    </header>
  );
};

export default Header;
